import React from 'react';
import ActivitiesConstruction from '../components/ActivitiesConstruction';
import ActivitiesFlood from '../components/ActivitiesFlood';
import ActivitiesFlower from '../components/ActivitiesFlower';
import ActivitiesFuneral from '../components/ActivitiesFuneral';
import ActivitiesSnow from '../components/ActivitiesSnow';
import ActivitiesMarket from '../components/ActivitiesMarket';
import ActivitiesNav from '../components/ActivitiesNav';
import ActivitiesPark from '../components/ActivitiesPark';
import ActivitiesPublicCleaning from '../components/ActivitiesPublicCleaning';
import ActivitiesRealEstate from '../components/ActivitiesRealEstate';
import ActivitiesWaste from '../components/ActivitiesWaste';
import ScrollIntoView from '../components/ScrollIntoView';

const Activities = () => {
  return (

    <ScrollIntoView>
      <div id="activities-page">
        
        <ActivitiesNav />

        <ActivitiesWaste />

        <ActivitiesRealEstate />

        <ActivitiesConstruction />

        <ActivitiesPark />

        <ActivitiesFlood />

        <ActivitiesMarket />

        <ActivitiesPublicCleaning />

        <ActivitiesSnow />
        
        <ActivitiesFuneral />

        <ActivitiesFlower />

      </div>

    </ScrollIntoView>

  );
};

export default Activities;